import { render, staticRenderFns } from "./step-transfer.vue?vue&type=template&id=6956a68f&"
import script from "./step-transfer.vue?vue&type=script&lang=js&"
export * from "./step-transfer.vue?vue&type=script&lang=js&"
import style0 from "./step-transfer.vue?vue&type=style&index=0&id=6956a68f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports